import type { IItem } from '@/interfaces'

export class Item implements IItem {
	itemCode: string | null
	itemName: string | null
	groupCode: number | null
	groupName: string | null
	purchaseItem: boolean | null
	sellItem: boolean | null
	inventoryItem: boolean | null

	constructor({
		itemCode = null,
		itemName = null,
		groupCode = null,
		groupName = null,
		purchaseItem = null,
		sellItem = null,
		inventoryItem = null
	}: Partial<IItem> = {}) {
		this.itemCode = itemCode
		this.itemName = itemName
		this.groupCode = groupCode
		this.groupName = groupName
		this.purchaseItem = purchaseItem
		this.sellItem = sellItem
		this.inventoryItem = inventoryItem
	}
}
